var _defs, _path, _path2, _path3, _path4, _path5, _line, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoiEstDespWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-1{opacity:0.2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.84,27.31V16.69a3.91,3.91,0,0,1,3.9-3.91H18.37a3.91,3.91,0,0,0-3.91,3.91V27.31a3.91,3.91,0,0,0,3.91,3.91h2.37A3.91,3.91,0,0,1,16.84,27.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.12,19.19a.78.78,0,0,0-.78-.78H25a1.17,1.17,0,0,1-1.17-1.18V15.91a.79.79,0,1,0-1.57,0v1.32A2.74,2.74,0,0,0,25,20h1.33A.78.78,0,0,0,27.12,19.19Zm-8.71-5.63a3.13,3.13,0,0,0-3.13,3.13V27.31a3.13,3.13,0,0,0,3.13,3.13h7.18a3.13,3.13,0,0,0,3.13-3.13V16.69a3.13,3.13,0,0,0-3.13-3.13ZM25.59,32H18.41a4.69,4.69,0,0,1-4.69-4.69V16.69A4.69,4.69,0,0,1,18.41,12h7.18a4.69,4.69,0,0,1,4.69,4.69V27.31A4.69,4.69,0,0,1,25.59,32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.25,28.05l4.61-4.81a.78.78,0,0,0,0-1.1.79.79,0,0,0-1.11,0L19.12,27a.79.79,0,0,0,0,1.1.75.75,0,0,0,.54.22A.77.77,0,0,0,20.25,28.05Zm2.88-.74a1,1,0,1,0,1-1A1,1,0,0,0,23.13,27.31Zm-3.29-5.39a1,1,0,1,1-1,1A1,1,0,0,1,19.84,21.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.9,29a.5.5,0,0,0,.36.94l3.19-1.22,1,3.18c.11.48,1,.3,1-.28l-1.12-3.72a.48.48,0,0,0-.63-.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.18,37.53a15.57,15.57,0,0,0,14.07-9.34.49.49,0,0,1,.62-.27h0a.5.5,0,0,1,.26.66,16.57,16.57,0,0,1-15,9.94"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.03,
    y1: 35.86,
    x2: 22,
    y2: 40.09
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,40.59h0a.5.5,0,0,1-.5-.5l0-4.23a.51.51,0,0,1,.5-.5h0a.5.5,0,0,1,.49.51l0,4.23A.5.5,0,0,1,22,40.59Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoiEstDespWhite);
export default __webpack_public_path__ + "static/media/ROI_estDesp_white.71759f0855b7d4a9bec9c646884245b3.svg";
export { ForwardRef as ReactComponent };